import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Route } from '@angular/compiler/src/core';


@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {
  private isAuthenticated: boolean = false;
  constructor(
    private router: Router
  ) {

  }


  canActivate() {
    const token = localStorage.getItem('token');
    if (token) {
      this.isAuthenticated = true;
      return this.isAuthenticated;
    } else {
      this.router.navigate(['/']);
      return false;
    }
    
  }
}
